import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import 'whatwg-fetch'
import { createHead } from '@vueuse/head'
import i18n from './i18n'


const head = createHead()
const app = createApp(App)

app.use(router)
app.use(head)
app.use(i18n)

app.mount('#app')

// const originalPush = router.push.bind(router)
// router.push = function (location: any) {
//     console.trace('[router.push] called with', location)
//     return originalPush(location)
// }